import dayjs from "dayjs";
import { useContext } from "react";
import { Button } from "../components/BaseComponents";
import { getCSRFToken } from "../lib/utils";
import usePublicApi from "../hooks/usePublicApi";
import { userContext } from "../context/UserContext";

type TrainingNotStartedProps = {
    startDate?: string;
};

// Decision 11 (docs/todo/admin-user-training-sessions.md): shown instead of the app for a
// training user whose session hasn't reached its startDate yet.
function TrainingNotStarted({ startDate }: TrainingNotStartedProps) {
    const publicApi = usePublicApi();
    const { clearUserData } = useContext(userContext);

    const onLogout = async () => {
        await publicApi.post('/user/logout', {
            _csrf: await getCSRFToken(),
        });
        clearUserData();
        window.location.reload();
    }

    return (
        // This page renders outside AppRouter's flex wrapper (UserContext short-circuits before
        // it mounts), so it's the sole block-level child of #root. Without the flex container
        // below, the inner div's mt-16 collapses through #root's own top margin, pushing #root's
        // background down and exposing the browser's default white body background above it.
        <div className="flex flex-col items-center min-h-dvh">
            <div className="content w-[32rem] mt-16 text-center">
                <div className="text-charcoal-100 text-2xl">Training has not started yet</div>
                <div className="mt-8 text-charcoal-100">
                    <div>Your training session has not started yet.</div>
                    {startDate && (
                        <div className="mt-4">
                            Please check back after <span>{dayjs(startDate).format('DD MMMM YYYY, HH:mm')}</span>.
                        </div>
                    )}
                </div>
                <Button type="Primary" text="Log out" additionalClass="mt-8" onClick={onLogout} />
            </div>
        </div>
    );
}

export default TrainingNotStarted;
